import { useEffect, useState } from "react";
import { PageHero } from "@/pages/About";
import { ProjectCard } from "@/pages/ImpactHub";
import { api } from "@/lib/api";

export default function SuccessStories() {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        api.get("/public/projects?is_success_story=true").then(({ data }) => setItems(data.items || [])).finally(() => setLoading(false));
    }, []);

    return (
        <div data-testid="success-stories">
            <PageHero title="Success Stories" subtitle="Verified community transformation" />
            <section className="gsf-section">
                <div className="gsf-container">
                    <p className="max-w-3xl text-[color:var(--gsf-body)] leading-relaxed text-lg">
                        Every success story shown here documents a specific community intervention with photos, videos,
                        testimonials and verified outcomes. Stories are published only after review by Foundation
                        administrators.
                    </p>
                    {loading ? (
                        <p className="mt-8 text-gray-500">Loading…</p>
                    ) : items.length === 0 ? (
                        <div className="mt-10 gsf-card p-8 max-w-2xl" data-testid="stories-empty">
                            <div className="gsf-eyebrow">Coming soon</div>
                            <h3 className="mt-2 font-serif text-xl text-[color:var(--gsf-green-700)] font-semibold">
                                Success stories will appear here as verified projects are published.
                            </h3>
                        </div>
                    ) : (
                        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                            {items.map((p) => <ProjectCard key={p.slug} project={p} />)}
                        </div>
                    )}
                </div>
            </section>
        </div>
    );
}
